import { render, staticRenderFns } from "./InventoryAdvancePaymentDetailActivityCard.vue?vue&type=template&id=0ffb7b22&"
import script from "./InventoryAdvancePaymentDetailActivityCard.vue?vue&type=script&lang=ts&"
export * from "./InventoryAdvancePaymentDetailActivityCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports